import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import AdminHeader from '../components/admin/AdminHeader';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Fungsi untuk mendapatkan judul halaman berdasarkan path
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/admin/dashboard')) return 'Dashboard';
    if (path.includes('/admin/products')) return 'Manajemen Produk';
    if (path.includes('/admin/categories')) return 'Manajemen Kategori';
    if (path.includes('/admin/articles')) return 'Manajemen Artikel';
    if (path.includes('/admin/gallery')) return 'Manajemen Galeri';
    if (path.includes('/admin/settings')) return 'Pengaturan';
    return 'Admin';
  };

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'dashboard', path: '/admin/dashboard' },
    { id: 'products', label: 'Manajemen Produk', icon: 'inventory_2', path: '/admin/products' },
    { id: 'categories', label: 'Manajemen Kategori', icon: 'category', path: '/admin/categories' },
    { id: 'articles', label: 'Manajemen Artikel', icon: 'article', path: '/admin/articles' },
    { id: 'gallery', label: 'Manajemen Galeri', icon: 'gallery_thumbnail', path: '/admin/gallery' },
    { id: 'users', label: 'Manajemen User', icon: 'group', path: '/admin/users' },
    { id: 'settings', label: 'Pengaturan Umum', icon: 'settings', path: '/admin/settings' },
  ];

  const handleLogout = () => {
    // Hapus token dari localStorage
    localStorage.removeItem('admin_token');
    // Redirect ke halaman login
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa] dark:bg-[#0f0f0e] transition-colors duration-300">
      <div className="flex">
        {/* Mobile Sidebar Overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black/60 z-40 md:hidden backdrop-blur-sm transition-opacity"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside className={`w-72 bg-[#171612]/95 backdrop-blur-xl border-r border-white/5 fixed h-full z-50 flex flex-col transition-transform duration-300 ease-in-out shadow-2xl ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        }`}>
          <div className="p-8 flex-1 flex flex-col">
            <div className="flex items-center gap-4 mb-12 px-2">
              <div className="bg-white/5 p-1.5 size-12 rounded-xl flex items-center justify-center shadow-lg ring-1 ring-white/10 backdrop-blur-md">
                <img loading="lazy" src="/assets/favicon.png" alt="Jati Antik Logo" className="w-full h-full object-contain drop-shadow-md" />
              </div>
              <div className="flex flex-col">
                <h1 className="text-white text-xl font-black leading-tight tracking-tight">Jati Antik</h1>
                <p className="text-[#d4af35] text-[10px] font-black uppercase tracking-[0.25em] opacity-80">Admin Console</p>
              </div>
            </div>

            <nav className="flex flex-col gap-1.5 flex-1">
              <div className="px-4 py-2 text-[10px] font-black text-[#5c584a] uppercase tracking-[0.2em] mb-2 opactiy-50">Menu Utama</div>
              <ul className="flex flex-col gap-1.5 list-none p-0 m-0">
                {menuItems.map((item) => (
                  <li key={item.id}>
                    <Link
                      to={item.path}
                      onClick={() => setSidebarOpen(false)}
                      className={`flex items-center gap-3.5 px-4 py-3.5 rounded-xl transition-all duration-300 group relative overflow-hidden ${
                        location.pathname === item.path
                          ? 'bg-gradient-to-r from-[#d4af35] to-[#bfa030] text-[#171612] shadow-xl shadow-[#d4af35]/20 font-bold'
                          : 'text-[#857d66] hover:bg-white/5 hover:text-white font-medium'
                      }`}
                    >
                      <span className={`material-symbols-outlined text-xl relative z-10 transition-all duration-500 ${
                        location.pathname === item.path ? 'scale-110' : 'group-hover:scale-110 group-hover:rotate-6'
                      }`}>{item.icon}</span>
                      <span className="text-sm relative z-10 tracking-tight">{item.label}</span>
                      {location.pathname === item.path && (
                        <div className="absolute inset-0 bg-white/20 opacity-100 animate-pulse"></div>
                      )}
                    </Link>
                  </li>
                ))}
                
                <div className="mt-auto pt-8 border-t border-white/5">
                  <div className="px-4 py-2 text-[10px] font-black text-[#5c584a] uppercase tracking-[0.2em] mb-2 opactiy-50">Sistem</div>
                  <li>
                    <button
                      onClick={handleLogout}
                      className="flex items-center gap-3.5 px-4 py-3.5 rounded-xl text-red-400 hover:bg-red-500/10 transition-all w-full group font-bold border border-transparent hover:border-red-500/20"
                    >
                      <span className="material-symbols-outlined group-hover:-translate-x-1 transition-transform text-xl">logout</span>
                      <span className="text-[11px] font-black uppercase tracking-[0.15em] opacity-80 group-hover:opacity-100 transition-opacity whitespace-nowrap">Keluar Panel</span>
                    </button>
                  </li>
                </div>
              </ul>
            </nav>
          </div>
          
          {/* User Info at Sidebar Bottom */}
          <div className="p-6 bg-black/20 border-t border-white/5">
            <div className="flex items-center gap-3">
              <div className="size-10 rounded-full border-2 border-[#d4af35]/30 p-0.5">
                <div className="w-full h-full rounded-full bg-cover bg-center" style={{backgroundImage: 'url("https://placehold.co/40x40/d4af35/171612?text=AD")'}}></div>
              </div>
              <div className="flex flex-col">
                <span className="text-[13px] font-black text-[#171612] dark:text-white leading-none mb-1 tracking-tight">Admin Jati Antik</span>
                <span className="text-[10px] font-bold text-[#d4af35] uppercase tracking-[0.1em]">Super Administrator</span>
                <div className="flex items-center gap-1.5 mt-1">
                  <div className="size-1.5 rounded-full bg-green-500 animate-pulse"></div>
                  <p className="text-[#857d66] text-[10px] uppercase font-bold tracking-wider">Online</p>
                </div>
              </div>
            </div>
          </div>
        </aside>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-h-screen md:ml-72">
          <AdminHeader sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          {/* Content Area */}
          <main className="flex-1 bg-[#f4f6f8] dark:bg-[#12110f] p-6 md:p-12 font-sans overflow-x-hidden">
            <div className="max-w-7xl mx-auto w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;